import { useEffect } from 'react';
import { SVGIcon, useTranslations } from '@omnipkg/ui-kit-web';

import FlowManager from '@src/components/FlowManager';
import Message from '@src/components/Message/Message';
import { useFlowManagerContext } from '@src/contexts/FlowManagerContext';
import { Path } from '@src/types/routes';

const icon = <SVGIcon name="like-face" fillVariant="primary" size={100} />;

export default function Like() {
  const { setButtonState } = useFlowManagerContext();
  const { t } = useTranslations();

  useEffect(() => {
    setButtonState({
      text: t('backHome'),
      isActive: true,
      isLoading: false,
      link: { to: Path.Main },
    });
  }, [setButtonState, t]);

  return (
    <FlowManager>
      <Message icon={icon} title={t('thankYou')}>
        {t('weHopeSeeSoon')}
      </Message>
    </FlowManager>
  );
}
